import { useItemsContext } from "Pages/PreBudgetConvertion/hooks/useItemsContext";
import React, { useState } from "react";

import { FakePromise } from "Utils/Promise";
import { createToast } from "Utils/toastFunc";
import { CartListItems } from "./CartAttendmenList";

export const CartSummary = () => {
  const [productIdOperation, setProductIdOperation] = useState<null | number>(
    null
  );

  const {
    items,
    addQuantityItem,
    deleteQuantityItem,
    blockUserInteraction,
    deleteItem,
  } = useItemsContext();

  const addUnitItem = async (productId: number) => {
    setProductIdOperation(productId);
    await FakePromise(1000);
    addQuantityItem(productId);
    createToast("success", "Quantidade atualiza com sucesso!");
    setProductIdOperation(null);
  };

  const removeUnitItem = async (productId: number) => {
    setProductIdOperation(productId);
    await FakePromise(1000);
    deleteQuantityItem(productId);
    createToast("success", "Quantidade atualiza com sucesso!");
    setProductIdOperation(null);
  };

  return (
    <div className="tab-item">
      <h5 className="text-center">
        Resumo:{" "}
        <span>
          {items.length || 0} {items.length === 1 ? "item" : "itens"}
        </span>{" "}
        no orçamento
      </h5>

      <CartListItems
        items={items}
        addUnitItem={addUnitItem}
        removeUnitItem={removeUnitItem}
        deleteItem={deleteItem}
        loadingOperation={productIdOperation}
        blockedUserInteraction={blockUserInteraction}
      />
    </div>
  );
};
